import {filters} from "@atttomyx/shared-constants";

export const getNodeFilters = (nodes, edges) => {
    const keyToMetadata = {
        firstName: {
            type: filters.TYPE_STRING,
        },
        lastName: {
            type: filters.TYPE_STRING,
        },
    };

    // todo: implement
    // questions.forEach(question => {
    //     const questionId = question.id;
    //
    //     keyToMetadata[questionId] = {
    //         type: filters.TYPE_STRING,
    //         label: question.ask,
    //         getter: (item) => item.questions[questionId],
    //     };
    // });

    return keyToMetadata;
};
